import CandidacyElectionComponent from '@/public/vote/components/election-types/candidacy-election-component/candidacy-election-component.vue';
import { ICandidatureElectionVote } from '@/public/vote/models/candidature-election-vote';
import { IElectionInitializationReceipt } from '@/public/vote/models/election-initialization-receipt';
import { IPreparedAdditionalData } from '@/public/vote/models/prepared-additional-data';
import { IVoteValidationError } from '@/public/vote/services/vote-validation-service';
import { IElection } from '@/shared/models/election';
import { IVotingSettings } from '@/shared/models/voting-settings';
import _ from 'lodash';
import { Component, Emit, Prop, Vue } from 'vue-property-decorator';

@Component({
    name: 'electionComponent',
    components: {
        CandidacyElectionComponent
    }
})
export default class ElectionComponent extends Vue {

    @Prop() public election!: IElection;
    @Prop() public votingSettings!: IVotingSettings;
    @Prop() public translations!: { [key: string]: string; };
    @Prop() public level!: number;
    @Prop({default: true}) public showProfilePictures!: boolean;
    @Prop() public allValidationErrors!: IVoteValidationError[];
    @Prop({default: null}) public preparedAdditionalData!: IPreparedAdditionalData[];

    @Emit('changed')
    public emitVoteChanged(votes: ICandidatureElectionVote): ICandidatureElectionVote {

        return votes;
    }

    @Emit('initiated')
    public emitInitiated(receipt: IElectionInitializationReceipt): IElectionInitializationReceipt {

        return receipt;
    }

    public handleVoteChanged(votes: ICandidatureElectionVote): void {

        this.emitVoteChanged(votes);
    }

    public get validationErrors(): string[] {

        const errors: string[] = [];

        this.allValidationErrors.forEach(x => {

            if (x.electionId.id.toLowerCase() !== this.election.electionId.id.toLowerCase()) {
                return;
            }

            const typeAsString = _.camelCase(x.type);

            const errorMessage = this.translations[`validation_message_${typeAsString}`];

            errors.push(errorMessage || typeAsString);
        });

        return errors;
    }

}
